import { render, staticRenderFns } from "./ModalCartTimeWarning.vue?vue&type=template&id=2842a23f&"
import script from "./ModalCartTimeWarning.vue?vue&type=script&lang=js&"
export * from "./ModalCartTimeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports